import React, { Component } from 'react'
import jQuery from 'jquery'
import { darken } from '@mui/material/styles'
import { Button } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import { JIRA_COLLECTOR_URL } from 'qap/constants'

import QAPVars from 'qap/vars'

type Props = {
  classes: any;
};

const styles = (theme: any) => ({
  root: {
    position: 'fixed',
    bottom: 85,
    '@media (min-height: 800px)': {
      bottom: '15vh'
    },
    right: 0,
    backgroundColor: QAPVars.coolGray,
    color: QAPVars.white,
    zIndex: 1,
    minWidth: 0,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: darken(QAPVars.coolGray, 0.15)
    },
    '@media print': {
      display: 'none'
    }
  },

  icon: {
    fontSize: 22,
    transform: 'scaleX(-1)'
  },
})

class Feedback extends Component<Props> {
  showDialog = null

  componentDidMount () {
    if (JIRA_COLLECTOR_URL) {
// @ts-expect-error - TS2339 - Property 'jQuery' does not exist on type 'Window & typeof globalThis'.
      window.jQuery = jQuery

// @ts-expect-error - TS2339 - Property 'ATL_JQ_PAGE_PROPS' does not exist on type 'Window & typeof globalThis'.
      window.ATL_JQ_PAGE_PROPS = {
// @ts-expect-error - TS7006 - Parameter 'showDialog' implicitly has an 'any' type.
        triggerFunction: (showDialog) => {
          this.showDialog = showDialog
        }
      }

      jQuery.ajax({
        url: JIRA_COLLECTOR_URL,
        type: 'get',
        cache: true,
        dataType: 'script'
      })
    }
  }

  handleClick = () => {
// @ts-expect-error - TS2349 - This expression is not callable.
    this.showDialog && this.showDialog()
  }

  render () {
    if (!JIRA_COLLECTOR_URL) return null

    const { classes } = this.props
    return (
      <Button
        id='feedback-button'
        className={classes.root}
        onClick={this.handleClick}
        title='Feedback'
      >
        <ChatBubbleOutlineIcon className={classes.icon} />
      </Button>
    )
  }
}

// @ts-expect-error - TS2345 - Argument of type '(theme: any) => { root: { position: string; bottom: number; '@media (min-height: 800px)': { bottom: string; }; right: number; backgroundColor: string; color: string; zIndex: number; minWidth: number; padding: any; '&:hover': { ...; }; '@media print': { ...; }; }; icon: { ...; }; }' is not assignable to parameter of type 'Styles<any, any, string>'.
export default withStyles(styles)(Feedback)
